module.exports = __webpack_public_path__ + "static/media/fo.67b9c0ea.gif";